<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content">

      <div class="project-page-content">

        <div style="width: 750px;">

          <h3>My Organizations</h3>

        </div>

        <div style="margin-top: 42px; margin-bottom: 48px;" *ngIf="isSystemAdmin()">

          <!-- system admins may create organizations  -->

          <p-inputgroup>

            <input (keyup)="checkKey()" id="createorganizationkeylight" type="text" pInputText placeholder="Key">
            <input (keyup)="checkKey($event)" id="createorganizationlight" type="text" pInputText placeholder="New Organization">

            <div *ngIf="orgInputValid; then checkButton else cancelButton"></div>
            <ng-template #checkButton>
              <button (click)="createOrganization()" type="button" pButton pRipple icon="pi pi-check" [class.p-button-danger]="!orgInputValid" [class.p-button-success]="orgInputValid"></button>
            </ng-template>

            <ng-template #cancelButton>
              <button (click)="createOrganization()" type="button" pButton pRipple icon="pi pi-times" [class.p-button-danger]="!orgInputValid" [class.p-button-success]="orgInputValid"></button>
            </ng-template>

          </p-inputgroup>

          <div>
            <p class="orgcreateerror"></p>
          </div>

        </div>

        <div *ngIf="(organizations.length == 0) && (organizations.length == 0); then thenBlock else elseBlock"></div>

        <ng-template #thenBlock>

          <!-- there aren't in any organizations yet. -->

          <p><i>No organizations yes.</i></p>


        </ng-template>

        <ng-template #elseBlock>

          <div *ngIf="organizations.length">

            <h6>Organizations</h6>

            <organization-list-component [editable]="true" [organizations]="organizations"></organization-list-component>

          </div>

        </ng-template>

        <div style="margin-top: 24px; max-width: 650px;">
        <p-accordion  class="light">

          <p-accordionTab header="Help">

            <p>Organizations are used to group users into their own organizations. An organization can also have some
              members are designated as administrators, and they modify and update the projects and users within the
              organizations where they are an administrator.  Only system admins can modify and update all possible
              organizations.</p>

            <p>Within an organization, users and subdivisions can be assigned to projects.  Users can only see
              the panoramas that are within subdivisions that are assigned to the same projects where users are
              assigned.  This setup allows user access to be scoped and managed by the organizational admins.
            </p>

            <p>Only subdivisions assigned to organizations can be assigned to projects within
              an organization, and only system admins can modify the subdivisions assigned to organizations.
              Also, only system admins can assign or unassign organizational administrators.  </p>

            <p>If you require access to additional projects please contact your manager for further assistance.</p>

            <p>To create a new Organizations use the Create input below.
              Note that organizations require a unique key and a name.  The unique key can start with A-Z,
              and the rest of the key can be _, A-Z, or 0-9.
            </p>

          </p-accordionTab>

        </p-accordion>
        </div>

      </div>

    </div>

    <div id="pano-footer" class="pano-footer"></div>

  </div>
</div>
